"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var styles_1 = require("@material-ui/core/styles");
var carDetailsWithFinanceStyles = styles_1.makeStyles(function (_a) {
    var _b, _c;
    var breakpoints = _a.breakpoints;
    return ({
        wrapper: {
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            padding: '5px',
        },
        multiWrapper: (_b = {},
            _b[breakpoints.down('xs')] = {
                flexDirection: 'column',
            },
            _b),
        prices: {
            marginLeft: '5px',
            display: 'flex',
            alignItems: 'center',
        },
        divider: (_c = {
                margin: '0 5px',
                height: '15px'
            },
            _c[breakpoints.down('xs')] = {
                margin: '0 2px',
                height: '10px',
            },
            _c),
    });
}, { name: 'Summary_CarDetailsWithFinance' });
exports.default = carDetailsWithFinanceStyles;
